import { CREATE_PRICE_LIST_FAILURE, CREATE_PRICE_LIST_REQUEST, CREATE_PRICE_LIST_SUCCESS, CREATE_USERFORM_PRICE_LIST, DELETE_PRICE_LIST_FAILURE, DELETE_PRICE_LIST_REQUEST, DELETE_PRICE_LIST_SUCCESS, FETCH_ALL_PRICE_LIST_FAILURE, FETCH_ALL_PRICE_LIST_REQUEST, FETCH_ALL_PRICE_LIST_SUCCESS, FETCH_BY_ID_PRICE_LIST_FAILURE, FETCH_BY_ID_PRICE_LIST_REQUEST, FETCH_BY_ID_PRICE_LIST_SUCCESS, RESET_PRICE_LIST_USERFORM, UPDATE_PRICE_LIST_FAILURE, UPDATE_PRICE_LIST_REQUEST, UPDATE_PRICE_LIST_SUCCESS } from "./PriceList.actionType";

export const PRICE_LIST = 'priceList';

let initialState = {
    loading: false,
    priceList: [],
    userform: {},
    errorMessage: '',
}

export let PriceListReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_PRICE_LIST_REQUEST:
        case FETCH_BY_ID_PRICE_LIST_REQUEST:
        case CREATE_PRICE_LIST_REQUEST:
        case UPDATE_PRICE_LIST_REQUEST:
        case DELETE_PRICE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ALL_PRICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                priceList: updatePayload
            }
        case FETCH_BY_ID_PRICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case CREATE_USERFORM_PRICE_LIST:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_PRICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case UPDATE_PRICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case DELETE_PRICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case FETCH_ALL_PRICE_LIST_FAILURE:
        case FETCH_BY_ID_PRICE_LIST_FAILURE:
        case CREATE_PRICE_LIST_FAILURE:
        case UPDATE_PRICE_LIST_FAILURE:
        case DELETE_PRICE_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case RESET_PRICE_LIST_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {},
            };

        default:
            return state;
    }
}